import { render, staticRenderFns } from "./cocktail-tall-5.vue?vue&type=template&id=4ab2f5c4"
import script from "./cocktail-tall-5.vue?vue&type=script&lang=js"
export * from "./cocktail-tall-5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports